export enum StatusColorEnum {
  not_created = '#DEBE0B',
  created = '#4CAF50',
}

export const Status = ({ value }: { value: any }) => {
  return (
    <div className={'flex flex-row items-center justify-center space-x-3'}>
      <span
        style={{
          // @ts-ignore - .
          backgroundColor: StatusColorEnum[value],
          width: 8,
          height: 8,
          borderRadius: 8,
          // @ts-ignore - .
          boxShadow: `0 0 5px ${StatusColorEnum[value]}`,
          display: 'inline-block',
        }}
      />
    </div>
  );
};
